import { CalendarClock, PowerOff, RefreshCw } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";

const TERMS = [
  ["Mindestlaufzeit", "12 Monate"],
  ["Abrechnung", "monatlich"],
  ["Kündigungsfrist", "1 Monat zum Ende der Laufzeit"],
  ["Danach", "Verlängerung um jeweils 1 Monat"],
];

const TOTALS = [
  ["Basic", "49 € / Monat", "588 € brutto in 12 Monaten"],
  ["Business", "79 € / Monat", "948 € brutto in 12 Monaten"],
  ["Premium", "99 € / Monat", "1.188 € brutto in 12 Monaten"],
];

export default function ContractTerms() {
  return (
    <section id="vertrag" className="relative py-14 lg:py-20 border-t border-white/10 bg-[#0b0806]/70" data-testid="contract-terms">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FF3B00]" /> Transparente Konditionen
            </Reveal>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.98] tracking-tight text-white uppercase mb-6">
              <MaskLineInView>12 Monate planbar</MaskLineInView>
              <MaskLineInView delay={0.1}>starten. Danach</MaskLineInView>
              <MaskLineInView delay={0.2} className="text-[#FF3B00]">monatlich flexibel.</MaskLineInView>
            </h2>
            <Reveal delay={0.15} className="text-neutral-300 text-base leading-relaxed mb-8">
              Nach der 12-monatigen Mindestlaufzeit verlängert sich Ihr Website-Service lediglich um
              jeweils einen weiteren Monat. Sie sind also nicht erneut ein ganzes Jahr gebunden.
            </Reveal>
            <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
              {TERMS.map(([k, v]) => (
                <div key={k} className="bg-[#100b07] p-5">
                  <p className="font-tech text-[11px] uppercase tracking-[0.14em] text-neutral-500 mb-1">{k}</p>
                  <p className="text-white text-sm">{v}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <Reveal className="flex items-center gap-3 text-neutral-400 mb-5">
              <CalendarClock size={18} className="text-[#FF3B00]" />
              <p className="font-tech text-xs uppercase tracking-[0.14em]">Gesamtbeträge während der Mindestlaufzeit</p>
            </Reveal>
            <div className="space-y-3">
              {TOTALS.map(([name, monthly, total], i) => (
                <Reveal key={name} delay={i * 0.06}>
                  <div className="flex items-center justify-between border border-white/10 bg-[#100b07] p-5">
                    <div>
                      <p className="font-display text-lg text-white">{name}</p>
                      <p className="text-neutral-500 text-xs mt-0.5">{monthly}</p>
                    </div>
                    <p className="text-[#FF3B00] font-display text-lg">{total}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <p className="text-neutral-600 text-xs mt-4">
              Alle Preise brutto. Keine jährliche Vorauszahlung – die Abrechnung erfolgt monatlich.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div className="border border-white/10 p-5">
                <PowerOff size={18} className="text-[#FF3B00] mb-3" />
                <p className="font-display text-base text-white mb-1">Offline nehmen</p>
                <p className="text-neutral-500 text-xs leading-relaxed">Nach einer Kündigung wird Ihr Webauftritt einfach offline genommen – anschließend fallen keine weiteren monatlichen Gebühren an.</p>
              </div>
              <div className="border border-white/10 p-5">
                <RefreshCw size={18} className="text-[#FF3B00] mb-3" />
                <p className="font-display text-base text-white mb-1">Jederzeit wieder aktivieren</p>
                <p className="text-neutral-500 text-xs leading-relaxed">Sie möchten später wieder online gehen? Ihr Webauftritt kann jederzeit wieder für Sie aktiviert werden.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
